export default {
      id: "products_bg-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "img/icons.svg#products_bg",
      toString: function () {
        return this.url;
      }
    }